import { BoxLabelIncident, BoxLabelIncidentStatus } from "@deliverr/commons-clients";

const SOLVABLE_INCIDENT_STATUSES = [BoxLabelIncidentStatus.NEEDS_NUM_PACKAGES, BoxLabelIncidentStatus.SOLVABLE];

export function incidentIsSolvable(incident?: BoxLabelIncident): boolean {
  return incident?.status ? SOLVABLE_INCIDENT_STATUSES.includes(incident.status) : false;
}
